import React from "react";
export type SideMenuContextState = {
  isOpen: boolean;
  openMenu: Function;
  hideMenu: Function;
};

const sideMenuContextDefaultValues: SideMenuContextState = {
  isOpen: false,
  openMenu: () => {},
  hideMenu: () => {},
};

export const SideMenuContext = React.createContext<SideMenuContextState>(sideMenuContextDefaultValues);
